import { render, staticRenderFns } from "./ShoppingList_Booking.vue?vue&type=template&id=8459cdb4&scoped=true&"
import script from "./ShoppingList_Booking.vue?vue&type=script&lang=js&"
export * from "./ShoppingList_Booking.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingList_Booking.vue?vue&type=style&index=0&id=8459cdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8459cdb4",
  null
  
)

export default component.exports